<template>
    <div>
        <brand-header/>
        <router-view></router-view>
    </div>
</template>
<script>
import BrandHeader  from '@/components/Brand/BrandHeader.vue'
import '@/assets/css/styles.css'

export default {
  name: 'BrandLayout',
  data: function () {
    return {
    }
  },
  components: {
    BrandHeader,
  },
}
</script>
